/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Order_Confirmation_Already_DecidedInputs */

const en_error_order_confirmation_already_decided = /** @type {(inputs: Error_Order_Confirmation_Already_DecidedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This confirmation was already answered, by you or a colleague.`)
};

/**
* | output |
* | --- |
* | "This confirmation was already answered, by you or a colleague." |
*
* @param {Error_Order_Confirmation_Already_DecidedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_order_confirmation_already_decided = /** @type {((inputs?: Error_Order_Confirmation_Already_DecidedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Order_Confirmation_Already_DecidedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_order_confirmation_already_decided(inputs)
});